// extracted by mini-css-extract-plugin
export default {"item":"FormatAmount_item__kzKfB","item_decimal":"FormatAmount_item_decimal__9mk28"};